import { render } from "./DrawerTransition.vue?vue&type=template&id=604ac1f0&ts=true"
import script from "./DrawerTransition.vue?vue&type=script&lang=ts"
export * from "./DrawerTransition.vue?vue&type=script&lang=ts"

import "./DrawerTransition.vue?vue&type=style&index=0&id=604ac1f0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__